// React Imports 
import React, { Component } from "react";

// Package Imports
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import { observer } from "mobx-react";
import * as images from "constants/Images";

// CSS Imports
import "./customization-modal.css";
import SolutionStore from "modules/solution/store/SolutionStore";

const   CustomizationModal = observer(
  class CustomizationModal extends Component {
    constructor(props) {
      super(props);

      this.state = {};
    }

    render() {

      const journeyId = window.location.pathname.split('/').slice(-1)[0]
      let coverage = localStorage.getItem('coverage')
      const showCoverageMsg = localStorage.getItem('showCoverageMsg')

      return (
        <div className='closeModalDiv d-flex align-items-center'>
          <Modal
            show={this.props.show}

            backdrop="static"
            onHide={() => { }}
            as='section'
            className='closeModal'
            aria-labelledby='contained-modal-title-vcenter'
            centered
            keyboard={false}
          >
            <ModalBody className='closeModalBody'>
              <section className="d-flex align-items-center justify-content-center h-100">
                <div className='row closeModalContent'>
                  <div className='mr-lg-2 py-4 my-3 text-center w-100 d-flex flex-column justify-content-between d-flex flex-column justify-content-between'>
                    <img src={images.AppLogo} width={80} className="appLogo mx-auto p-2" />
                    <div className="m-auto customization-loader"></div>
                    {/* <p>{this.props.loaderMsg}</p> */}
                    <p>{(showCoverageMsg === "true" && coverage === "true") ? "Your Coverage is not 100% Utilized" : this.props.loaderMsg}</p>
                    <p>{SolutionStore.pdfGenerate && "Alrighty! Let’s have a look at the entire solution we have for you!"}</p>
                    <a className="customization-modal-cancel mt-5" href={`/${this.props.redirectPath}/`}>Cancel</a>
                  </div>
                </div>
              </section>
            </ModalBody>
          </Modal>
        </div>
      );
    }
  }
);

export default CustomizationModal;
